import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    TextButton,
    Text,
    Spacer,
} from '@zillow/constellation';

import { UserSelectors, EmailVerificationSelectors } from 'app/shared/selectors';
import propertyUtils from 'app/shared/utils/propertyUtils';
import userUtils from 'app/shared/utils/userUtils';
import EmailVerificationActions from 'app/shared/actions/EmailVerificationActions';
import ModalActions from 'app/shared/actions/ModalActions';

const VerifyEmailModal = ({
    handleResendEmailClick,
}) => {
    const dispatch = useDispatch();

    const { email, roles } = useSelector(state => UserSelectors.makeUser(state));

    const {
        inactiveListings,
        activeListings,
    } = useSelector(state => EmailVerificationSelectors.makeEmailVerification(state));
    const isAdmin = userUtils.isPostingPathAdmin(roles);
    const notificationText = `Email resent! The feed listings associated with your account will be added once you
              verify your email at ${email}.`;

    const onResendEmailClick = () => {
        if (isAdmin) {
            handleResendEmailClick(notificationText);
            dispatch(ModalActions.hideModal());
        } else {
            dispatch(EmailVerificationActions
                .sendSecurityToken({ emailVerificationType: 'claimFeedListings' }))
                .then((response) => {
                    if (response.success) {
                        handleResendEmailClick(notificationText);
                        dispatch(ModalActions.hideModal());
                    }
                });
        }
    };

    const renderAddress = (listing, i) => {
        const { formattedCompleteAddress } = propertyUtils.formatAddress(listing);
        return (
            <Spacer marginY="xs" key={i} data-test="address-list-item">
                <Text as="div">{formattedCompleteAddress}</Text>
            </Spacer>
        );
    };

    return (
        <Spacer paddingBottom="sm">
            <Text fontType="h6">
                We found listings associated with your email address from other sources.
            </Text>
            <Spacer marginY="sm">
                <Text data-test="email-text">
                    We&apos;ve sent an email to
                    {' '}
                    <b>{email}</b>
    .
                    Click the link in the email to confirm your email address and
                    access those listings in Zillow Rental Manager.&nbsp;
                    <TextButton onClick={onResendEmailClick} fontType="body">
                        Resend email
                    </TextButton>
                </Text>
            </Spacer>
            {
                activeListings.length > 0 && (
                    <Spacer marginY="xs">
                        <Text as="div" fontType="bodyHeading" data-test="active-listings">Active Listings</Text>
                        {activeListings.map((listing, i) => renderAddress(listing, i))}
                    </Spacer>
                )}

            {
                inactiveListings.length > 0 && (
                    <Spacer marginY="xs">
                        <Text data-test="inactive-listings" as="div" fontType="bodyHeading">Inactive Listings </Text>
                        {inactiveListings.map((listing, i) => renderAddress(listing, i))}
                    </Spacer>
                )}
        </Spacer>
    );
};

export default VerifyEmailModal;
